import { useState, useEffect, ElementType, ReactNode } from 'react'

interface Props {
  tag?: ElementType
  alignXs?: string
  alignS?: string
  alignM?: string
  alignL?: string
  className?: string
  children: ReactNode
}

const Row = ({
  tag: Tag = 'section',
  alignXs,
  alignS,
  alignM,
  alignL,
  className,
  children,
  ...rest
}: Props) => {
  const [rowClasses, setRowClasses] = useState<string[]>([])

  useEffect(() => {
    const classes: string[] = []

    const getAlignClasses = (aligns: string, size: string) => {
      return aligns.split(' ').forEach((align) => {
        classes.push(`${align}-${size}`)
      })
    }

    if (alignXs) {
      getAlignClasses(alignXs, 'xs')
    }

    if (alignS) {
      getAlignClasses(alignS, 's')
    }

    if (alignM) {
      getAlignClasses(alignM, 'm')
    }

    if (alignL) {
      getAlignClasses(alignL, 'l')
    }

    setRowClasses(classes)
  }, [alignXs, alignS, alignM, alignL])

  return (
    <Tag {...rest} className={`row ${className || ''} ${rowClasses.join(' ')}`}>
      {children}
    </Tag>
  )
}

export default Row
